<div class="p-3">
    <div
        class="close-modal"
        (click)="onClose()"
        (keydown.escape)="onClose()"
        tabindex="0"
    >
        <mat-icon>close</mat-icon>
    </div>

    <h1>{{ data.name ? data.name : "" }}</h1>

    <div class="learning-section-options mt-4">
        <button
            mat-stroked-button
            color="primary"
            (click)="addContainer()"
            class="mb-3"
        >
            <mat-icon>add</mat-icon> Container hinzufügen
        </button>

        @if (this.getPreviewLink()) {
        <a
            mat-flat-button
            color="primary"
            href="{{ this.getPreviewLink() }}"
            target="_blank"
        >
            <mat-icon>remove_red_eye</mat-icon> VORSCHAU
        </a>
        }


        @if (layouts$ | async; as lo) {
        <mat-form-field>
            <mat-label>Layout</mat-label>
            <mat-select
                [(value)]="selectedLayoutOption"
                (selectionChange)="onChangeLayout($event.value)"
            >
                @for (layout of lo; track layout.id) {
                <mat-option [value]="layout">{{
                    layout.name
                    }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
        }
    </div>

    <div
        class="learning-section-grid-container"
        cdkDropList
        cdkDropListOrientation="mixed"
        [style.gridTemplateColumns]="gridTemplateColumns"
        (cdkDropListDropped)="drop($event)"
    >
        @for (
        container of learningSectionContainer$ | async;
        track container.id
        ) {
        <div
            class="learning-section-grid-item"
            [style.grid-column]="container.fullWidth ? '1 / -1' : 'auto'"
            cdkDrag
            [cdkDragData]="container"
        >
            <div class="learning-section-grid-content">
                <span
                    title="Bearbeitung per Mausklick"
                    (click)="editLearningSectionSingleContainer(container)"
                    (keydown.enter)="
                            editLearningSectionSingleContainer(container)
                        "
                    tabindex="0"
                >
                    <div class="container-title">{{ container.title }}</div>
                    @if (container.content) {
                    <div class="container-content">
                        <div class="name">
                            {{ container.content.name }}
                        </div>
                        <div class="name">
                            {{ container.order }}
                        </div>
                        @if (container.content.constructor) {
                        <div class="type">
                            ({{
                            getLearningSectionContainerContentType(
                            container.content.constructor
                            .name
                            )?.label
                            }})
                        </div>
                        }
                    </div>
                    }
                </span>
                <div
                    class="remove"
                    tabindex="0"
                    (click)="removeItem(container)"
                    (keydown.enter)="removeItem(container)"
                >
                    <mat-icon>close</mat-icon>
                </div>
            </div>
        </div>
        }
    </div>
</div>